import { AuthLevel, generateApiPath } from '@guiker/api-definition'

export const paths = {
  payoutMethod: generateApiPath({ prefix: AuthLevel.AUTH, name: 'payout-method' }),
  payout: generateApiPath({ prefix: AuthLevel.AUTH, name: 'payout' }),
} as const
